import { useFormContext } from '@/app/workflows/components/v6/operations/settings/form/contexts/formContext';
import { Select, Stack } from '@mantine/core';
import { SettingTitle } from '@/app/workflows/components/v6/operations/settings/form/components/SettingTitle';
import { OperationsFormValues } from '@/app/workflows/components/v6/operations/settings/form/schema';

type MethodValue = NonNullable<OperationsFormValues['uvUnwrapping']>['method'];

const options: {
  value: MethodValue;
  label: string;
}[] = [
  {
    value: 'cube',
    label: 'Cube',
  },
  {
    value: 'isometric',
    label: 'Isometric',
  },
  {
    value: 'forwardBijective',
    label: 'Forward Bijective',
  },
  {
    value: 'fixedBoundary',
    label: 'Fixed Boundary',
  },
  {
    value: 'fastConformal',
    label: 'Fast Conformal',
  },
];

export function UvMethodSetting() {
  const form = useFormContext();

  const onChange = (value: string | null) => {
    if (!value) {
      return;
    }
    form.setValues((prev) => ({
      uvUnwrapping: { ...prev.uvUnwrapping, method: value as MethodValue },
    }));
  };

  return (
    <Stack gap='xs'>
      <SettingTitle title='Unwrapping Method' description='Method to be used for UV unwrapping.' />
      <Select data={options} onChange={onChange} value={form.values.uvUnwrapping?.method} />
    </Stack>
  );
}
